import axios from '../axiosHelper';
import Cookies from "js-cookie"

export default {
    state: {
        status: '',
        status_code: '',
        message: '',
        message_code: '',
        tahunAjaranList : [],
    },
    getters: {
        getTahunAjaranList: state => state.tahunAjaranList,
    },
    mutations: {
        request(state){
            state.status = 'LOADING'
        },
        success(state, { resp }){
            state.status = 'SUCCESS'
            if (resp) {
                state.status_code = resp.data.status
                state.message = resp.data.message
                state.message_code = resp.data.code
            }
        },
        error(state, { resp }){
            state.status = 'ERROR'
            if (resp) {
                state.status_code = resp.data.status
                state.message = resp.data.message
                state.message_code = resp.data.code
            }
        },
        setTahunAjaranList(state, { resp }){
            if (resp) {
                state.tahunAjaranList = resp.data.data
            }else{
                state.tahunAjaranList = [{}]
            }
        },
    },
    actions: {
        getTahunAjaranList({commit}){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v2/tahun-ajaran?token='+Cookies.get("token"),
                        method: 'GET'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        commit('setTahunAjaranList', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
        deleteTahunAjaran({commit}, form){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v2/tahun-ajaran/delete?token='+Cookies.get("token"),
                        data: form,
                        method: 'POST'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
        updateTahunAjaran({commit}, form){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v2/tahun-ajaran/edit?token='+Cookies.get("token"),
                        data: form,
                        method: 'POST'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
        addTahunAjaran({commit}, form){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v2/tahun-ajaran/add?token='+Cookies.get("token"),
                        data: form,
                        method: 'POST'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
    }
}
